import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { ReactNode } from 'react'
import type { KanbanCardApi } from './types'

interface Props {
  id: string
  children: (api: KanbanCardApi) => ReactNode
}

/**
 * Sortable-card wrapper. The consumer renders the actual card via the render-prop,
 * spreading `ref`, `style`, `attributes`, and `listeners` onto the element they want
 * to be the draggable handle.
 *
 * The consumer keeps full control of the JSX — useful for cards that need to be
 * `motion.div` for framer-motion shared-layout animation, etc.
 */
export function KanbanCard({ id, children }: Props) {
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id,
  })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return <>{children({ ref: setNodeRef, style, attributes, listeners, isDragging })}</>
}
